import { render, staticRenderFns } from "./MemberListTopCollectorLayout.vue?vue&type=template&id=c9e1ef1c&scoped=true&"
import script from "./MemberListTopCollectorLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListTopCollectorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e1ef1c",
  null
  
)

export default component.exports